<template>
	<div class="container-fluid">
		<div class="alert alert-danger m-1" v-show="errors != null">
			<div class="row d-flex justify-content-center align-items-center">
				<div class="col-12 col-sm-12 col-md-3 text-center h5" v-for="(item,index) in errors">
					{{item}}
				</div>
			</div>
		</div>
		<div class="m-2">
			<div class="row d-flex justify-content-center align-items-center mt-2">
				<div class="col-12 col-sm-6 col-md-2  col-lg-2 text-center">
					<input type="checkbox" class="form-check-input" id="pakt" v-model="product.aktiv">
					<label class="form-check-label" for="pakt">Aktív</label>
				</div>
				<div class="col-12 col-sm-6 col-md-4 col-lg-3">
					<div class="mui-textfield">
				    	<input type="text" v-model="product.nev">
				    	<label>Név</label>
				  	</div>
				</div>
				<div class="col-12 col-sm-6 col-md-4 col-lg-3">
					<div class="mui-textfield">
				    	<input type="text" v-model="product.maverix_nev">
				    	<label>Maverix megnevezés</label>
				  	</div>
				</div>
				<div class="col-12 col-sm-6 col-md-3 col-lg-2">
					<div class="mui-textfield">
				    	<input type="number" v-model="product.ar">
				    	<label>Ár</label>
				  	</div>
				</div>
				<div class="col-12 col-sm-6 col-md-3 col-lg-2">
					<div class="mui-textfield">
				    	<input type="text" v-model="product.suly">
				    	<label>Súly kg-ban (pl.: 1 vagy 0.7)</label>
				  	</div>
				</div>
				<div class="col-12 col-sm-6 col-md-3 col-lg-2">
					<div class="mui-select">
						<select v-model="product.listType">
							<option
								v-for="(v,k) in productListTypes"
								:key="k"
								:value="v.value"
							>
								{{ v.text }}
							</option>
						</select>
						<label>Rendelési csoport</label>
					</div>
				</div>
				<div class="col-12 col-md-6 col-lg-4">
					<div class="mui-textfield">
					    <textarea v-model="product.leiras"></textarea>
					    <label>Leírás</label>
					</div>
				</div>
				<div class="col-12 col-md-6 col-lg-4">
					<div class="mui-textfield">
					    <textarea v-model="product.megj"></textarea>
					    <label>Megjegyzés</label>
					</div>
				</div>
			</div>
		</div>
		<div class="m-2">
			<div class="row d-flex justify-content-center">
				<dir class="col-10 text-center">
					<button class="btn btn-success btn-lg" @click.prevent="save">
						<span v-show="change">Mentés</span>
						<span v-show="!change">Hozzáad</span>
					</button>
				</dir>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'product_data',
	props:['change','id'],
	data() {
		return {
			product: {},
			errors: null
	    }
	},
	mounted(){
	    if(this.change) {
	    	this.$Progress.start()
	    	this.req.post('/products/getdata',{
	    		id: this.id
	    	})
	    		.then(res => {
	    			this.product = res.data.product
	    			this.$Progress.finish()
	    		})
	    		.catch(err => {
	    			console.log(err)
	    			this.$Progress.fail()
	    		})
	    } else {
	    	this.product = {
	    		tszam: 0,
	    		nev: `-`,
	    		kep: `-`,
	    		leiras: `-`,
	    		megj: `-`,
	    		aktiv: false
	    	}
	    }
	},
	methods: {
		save(){
			this.$Progress.start()
			this.errors = null
	    	this.req.post('/products/save',{
	    		product: this.product,
	    		change: this.change
	    	})
	    		.then(res => {
	    			if(res.data.status === `error`) {
	    				this.errors = res.data.errors
	    				toastr.error(res.data.text)
	    				console.log(res.data.sql)
	    			} else {
	    				toastr.success(`${this.change?'Mentés':'Hozzáadás'} sikeres`)
	    			}
	    			this.$Progress.finish()
	    		})
	    		.catch(err => {
	    			toastr.error(err)
	    			this.$Progress.fail()
	    		})
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/admin/products/product_data.vue